import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIROLEMAPPING, EMAILCONFIG } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { APIROLEMAPPING_API, BaseGatewayAuth } from '../../utils/apiUrl.js';
import { FLASH_KEY } from '@app/utils/define';

export const apiRoleMappingPagingAction = createAsyncThunk(
    APIROLEMAPPING.GET_PAGING,
    async (model, { rejectWithValue }) => {
        try {
            // Fetch API role mappings
            const [response, authResponse] = await Promise.all([
                Get(APIROLEMAPPING_API.GET_PAGING_NOT_MENU, null, model),
                Get(APIROLEMAPPING_API.GET_PAGING_AUTH_NOT_MENU, null, model)
            ]);

            console.log('API Role Mapping Response:', response);

            const applicationMappings = response?.data ?? [];
            const authMappings = authResponse?.data ?? [];
            const mappings = [...applicationMappings, ...authMappings].reduce((result, mapping) => {
                const existingMapping = result.find((item) =>
                    String(item?.controller).toLowerCase() === String(mapping?.controller).toLowerCase()
                    && String(item?.action).toLowerCase() === String(mapping?.action).toLowerCase()
                );

                if (!existingMapping) return [...result, {...mapping}];

                const allowedRoles = [
                    ...(existingMapping.lstAllowedRoles ?? []),
                    ...(mapping.lstAllowedRoles ?? [])
                ].filter((role, index, roles) => index === roles.findIndex((item) =>
                    String(item?.name).toLowerCase() === String(role?.name).toLowerCase()
                ));
                existingMapping.lstAllowedRoles = allowedRoles;
                return result;
            }, []);

            if (response || authResponse) {
                const result = {
                    data: mappings,
                    totalRecords: mappings.length
                };

                return result;
            } else {
                localStorage.setItem(
                    FLASH_KEY,
                    JSON.stringify({ level: 'error', text: 'Tài khoản này không được sử dụng phần mềm này' })
                );

                userManager.removeUser();
                window.location.href = `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + "/")}`;

                state.isLoggedIn = false;
                state.error = null;

                return null;
            }

        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const initialState = {
    listApiRoleMapping: [],
    totalApiRoleMapping: 0,
    status: 'idle'
    // apiRoleMappingItem: null
};
export const apiRoleMappingSlice = createSlice({
    name: APIROLEMAPPING.NAME_SLICE,
    initialState,
    reducers: {
        filterListApiRoleMapping: (state, action) => {
            state.listApiRoleMapping =
                state.listApiRoleMapping.length > 0
                    ? state.listApiRoleMapping.filter(
                        (x) => x.id !== action.payload
                    )
                    : [];
            state.totalApiRoleMapping -= 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(apiRoleMappingPagingAction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(apiRoleMappingPagingAction.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.listApiRoleMapping =
                    action.payload && action.payload.data
                        ? action.payload.data
                        : [];
                state.totalApiRoleMapping = action.payload?.totalRecords ?? 0;
            })
            .addCase(apiRoleMappingPagingAction.rejected, (state) => {
                state.status = 'failed';
            });
    }
});

export const { filterListApiRoleMapping } = apiRoleMappingSlice.actions;

export default apiRoleMappingSlice.reducer;
